import { ControlledSelect } from '@if/mui'
import { MenuItem } from '@mui/material'
import { starPlanValues } from '@src/data/types/Constants'
import { Control, FieldPathByValue, FieldValues } from 'react-hook-form'
import { useTranslation } from 'react-i18next'

interface StarPlanSelectProps<T extends FieldValues> {
  name: FieldPathByValue<T, number>
  control: Control<T>
  disabled?: boolean
}

const StarPlanSelect = <T extends FieldValues>({ name, control, disabled }: StarPlanSelectProps<T>) => {
  const { t } = useTranslation()
  return (
    <ControlledSelect
      name={name}
      control={control}
      disabled={disabled}
      disableEmptyOption
      sx={{ minWidth: 200 }}
      slotProps={{ select: { inputProps: { 'aria-label': t('merchant.minimumApplicationStarPlan.title') } } }}
    >
      {starPlanValues.map((value) => (
        <MenuItem key={value} value={value}>
          {value === 1
            ? t('merchant.minimumApplicationStarPlan.acceptAll')
            : t('merchant.minimumApplicationStarPlan.option', { count: value })}
        </MenuItem>
      ))}
    </ControlledSelect>
  )
}

export default StarPlanSelect
